/* eslint-disable no-console */
/* eslint-disable operator-linebreak */
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { sendError } from '../../redux/actions';
import { segmentEvent } from '../../helpers/sendEvent';

// eslint-disable-next-line no-shadow
function ErrorHandling({ error, response, sendError }) {
  let friendlyErrorMessage = null;
  let muteError = false;

  if (!error) {
    return null;
  }

  // Wrong Verification Code
  if (response?.data?.error?.message === 'Invalid verification code') {
    segmentEvent('track', 'Mobile Number Verification Failed ');
    friendlyErrorMessage = 'Invalid verification code';
  }

  // Wrong Verification Code
  if (
    response?.data?.success === false ||
    response?.data === 'Invalid card: cannot be processed.' ||
    response?.data === 'The card number is invalid.'
  ) {
    friendlyErrorMessage = response?.data?.error?.Reason || 'Invalid card';
    const payload = JSON.parse(JSON.stringify({ katapultSDK: 'error', payload: friendlyErrorMessage }));
    window?.parent?.postMessage(payload, '*');
  }

  // SMS Blocked WD-236
  if (response?.data?.error?.type === 'sms_blocked') {
    muteError = true;
    sendError('sms_blocked');
  }

  if (muteError) {
    return null;
  }

  console.log('ErrorKey', error);
  console.log('ErrorMessage', response);

  sendError(JSON.stringify(response));

  if (response?.status && response?.status < 400) {
    friendlyErrorMessage = 'An unexpected error occurred. Please try again.';
    sendError(JSON.stringify(error));
  }

  if (friendlyErrorMessage) {
    return (
      <section>
        <div className="k-warning-section">
          {(friendlyErrorMessage && friendlyErrorMessage.toString()) ||
            'Unfortunately we are unable to complete your transaction.'}
        </div>
      </section>
    );
  }

  return <Redirect to="/support" />;
}

export default connect(null, { sendError })(ErrorHandling);
